import { create } from 'zustand';

interface PreviewTranslationStore {
  previewTranslationLocale: string | undefined;
  setPreviewTranslationLocale: (value: string | undefined) => void;
}

export const usePreviewTranslationStore = create<PreviewTranslationStore>(
  set => ({
    previewTranslationLocale: undefined,
    setPreviewTranslationLocale: (value: string | undefined) =>
      set({ previewTranslationLocale: value })
  })
);
